import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/store/auth";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Scissors, Loader2, ArrowLeft, ShieldCheck } from "lucide-react";

const REASON_MSG = {
  inactivity: "Cerramos tu sesión por seguridad, vuelve a entrar.",
  "other-device": "Tu sesión se cerró porque iniciaste sesión en otro dispositivo.",
  expired: "Tu sesión expiró. Vuelve a iniciar sesión.",
};

export default function Login() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const reasonMsg = REASON_MSG[params.get("reason")];
  const login = useAuth((s) => s.login);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email.trim(), password);
      toast.success("¡Bienvenido!");
      navigate(user.role === "admin" ? "/admin" : "/barber");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0f0f0f] flex items-center justify-center px-4">
      <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_top,_#d4af37_0%,_transparent_45%)]" />
      <div className="relative w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-[#a3a3a3] hover:text-[#f5f5f5] text-sm mb-6" data-testid="back-home">
          <ArrowLeft className="w-4 h-4" /> Volver al inicio
        </Link>
        <div className="nk-card p-8 animate-fade-up">
          <div className="flex items-center gap-2 mb-1">
            <Scissors className="w-7 h-7 text-[#d4af37]" />
            <h1 className="text-2xl font-extrabold">Barbería Nakama</h1>
          </div>
          <p className="text-[#a3a3a3] text-sm mb-6">Panel de administración y barberos</p>
          {reasonMsg && (
            <div className="flex items-start gap-2 mb-5 p-3 rounded-[10px] border border-[#d4af37]/40 bg-[#d4af37]/10 text-[#e9d9a6] text-sm" data-testid="login-reason-notice">
              <ShieldCheck className="w-4 h-4 text-[#d4af37] mt-0.5 shrink-0" />
              <span>{reasonMsg}</span>
            </div>
          )}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm text-[#a3a3a3] mb-1.5 block">Correo</label>
              <input data-testid="login-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="nk-input" placeholder="admin@nakama.mx" />
            </div>
            <div>
              <label className="text-sm text-[#a3a3a3] mb-1.5 block">Contraseña</label>
              <input data-testid="login-password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} className="nk-input" placeholder="••••••••" />
            </div>
            <button data-testid="login-submit" disabled={loading} className="nk-btn w-full flex items-center justify-center gap-2">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Ingresar
            </button>
          </form>
          <p className="text-center text-xs text-[#737373] mt-6">
            ¿Eres cliente? <Link to="/wallet" className="text-[#d4af37]">Consulta tus puntos aquí</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
